/* eslint-disable */
import ReportGamePerformanceList from './report-game-performance.list';

export default {
  // TODO: Temporarily use auto-render reports
  // list: ReportGamePerformanceList,
};
